<script setup>
import { onMounted, ref } from 'vue';
import { PhxIcon, slider } from '@phx-styleguides/iwc';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const sliderRef = ref(null);
const sliderInstance = ref(null);

onMounted(() => {
  if (sliderRef.value) {
    sliderInstance.value = slider(sliderRef.value, {
      threshold: 5,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
});
</script>

<template>
  <div
    :id="id"
    ref="sliderRef"
    class="slider slider--cards slider--nav-above slider–nav-end"
    role="group"
    aria-roledescription="carousel"
    :aria-label="ariaLabel"
  >
    <div class="slider__nav slider__nav--prev">
      <button type="button" class="btn btn--icon btn--icon-only btn--sm btn--icon btn--icon-only">
        <span class="btn__icon btn__icon--start">
          <phx-icon icon="triangle-left" class="icon--md" :bidirectional="true" />
        </span>
      </button>
    </div>

    <div class="slider__body" aria-atomic="false" aria-live="polite">
      <slot name="body" />
    </div>

    <div class="slider__nav slider__nav--next">
      <button type="button" class="btn btn--icon btn--icon-only btn--sm btn--icon btn--icon-only">
        <span class="btn__icon btn__icon--start">
          <phx-icon icon="triangle-right" class="icon--md" :bidirectional="true" />
        </span>
      </button>
    </div>

    <div class="slider__footer">
      <div class="slider__pagination" role="tablist" aria-label="Choose slide to display"></div>
    </div>
  </div>
</template>
